/* Convx: bind the award badges to their detail panels.
 *
 * The badges live in the text-icons strip and carry no href. Rather than give
 * them one, a click opens a panel underneath, so the shopper never leaves the
 * homepage. Binding is positional: badge 1 opens panel 1.
 *
 * The panels sit in their own section, which means the theme's
 * home_module_click handler will not attribute CTA clicks unless
 * ga-custom-events.js maps this section too. That mapping is added there.
 */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-cvx-awards]');
    if (!root) return;

    var strip = document.querySelector(root.getAttribute('data-strip') || '');
    if (!strip) return;

    var panels = [].slice.call(root.querySelectorAll('.cvx-awards__panel'));
    var items = [].slice.call(strip.querySelectorAll('.text-icons__item'));
    if (!panels.length || !items.length) return;

    strip.classList.add('cvx-awards-bound');

    function close(panel) {
      panel.classList.remove('is-open');
      var i = panels.indexOf(panel);
      if (items[i]) items[i].setAttribute('aria-expanded', 'false');
      strip.classList.remove('has-open');
    }

    function closeAll() {
      panels.forEach(close);
    }

    function toggle(index) {
      var panel = panels[index];
      if (!panel) return;
      var wasOpen = panel.classList.contains('is-open');
      closeAll();
      if (wasOpen) return;                       // second click collapses
      panel.classList.add('is-open');
      strip.classList.add('has-open');
      if (items[index]) items[index].setAttribute('aria-expanded', 'true');
      // Only scroll when the panel opened off-screen, so a click near the top
      // of the strip does not yank the page on desktop.
      var box = panel.getBoundingClientRect();
      if (box.bottom > window.innerHeight) {
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    items.forEach(function (item, index) {
      if (!panels[index]) return;                // more badges than panels
      // A badge whose panel is switched off stays exactly as it is on live:
      // no button role, no pointer, no handler.
      if (panels[index].getAttribute('data-disabled') === 'true') return;
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-expanded', 'false');
      item.setAttribute('aria-controls', panels[index].id);

      item.addEventListener('click', function (event) {
        // A badge that is already a link keeps its own behaviour.
        if (event.target.closest && event.target.closest('a[href]')) return;
        event.preventDefault();
        toggle(index);
      });

      item.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
        event.preventDefault();
        toggle(index);
      });
    });

    root.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-cvx-close]')) {
        closeAll();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });

    // A floating panel overlays content, so a click anywhere outside it has to
    // dismiss it. Clicks on a badge are handled by the badge's own listener.
    document.addEventListener('click', function (event) {
      if (!strip.classList.contains('has-open')) return;
      var t = event.target;
      if (!t.closest) return;
      if (t.closest('.cvx-awards__panel') || t.closest('.text-icons__item')) return;
      closeAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
